export const attached = {
  hylink_ac: "hylink_ac",
};

export default attached;
